import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    // Google Analytics – page_view manual (send_page_view: false no init)
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_title: document.title,
      });
    }

    // Facebook Pixel – PageView
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location]);
};

export default usePageTracking;
